import { DetailsSectionFlowContent } from 'app/main/components/page-layouts';
import { type FastAddDialogSettingsType } from 'app/main/modules/components/FastAddDialog';
import { DescriptionSection, InlineTitle } from 'app/main/modules/components/FastAddDialogSettingsManager';

import WorkReportsEvents from './WorkReportsEvents';

import WorkReportsDetailsSectionInfo from './details/sections/WorkReportsDetailsSectionInfo';
import WorkReportsDetailsSectionSecondaryInfo from './details/sections/WorkReportsDetailsSectionSecondaryInfo';

const dialogSettings: FastAddDialogSettingsType = {
	content: props => (
		<>
			<InlineTitle text="DETAILS_INFO_SECTION" />
			<WorkReportsDetailsSectionInfo {...props} />
			<InlineTitle text="DETAILS_SECONDARY_INFO_SECTION" />
			<WorkReportsDetailsSectionSecondaryInfo {...props} />
			<InlineTitle text="DETAILS_DESCRIPTION_SECTION" />
			<DescriptionSection
				name="wore_descriptionhtml"
				value={props.model.wore_descriptionhtml}
				isEdit={props.isEdit}
				sendChange={props.sendChange}
			/>
			<InlineTitle text="DETAILS_FLOW_SECTION" />
			<DetailsSectionFlowContent module="workreports" {...props} />
		</>
	),
	events: WorkReportsEvents,
	showOpenFullDetails: true
};

export default dialogSettings;
